import React from "react";

import PageHeader from "../../../../molecules/PatientDetailsV2/PageHeader/PageHeader";
import DietViews from "../../../../molecules/DietV2/DietViews/DietViews";

// The adherence graph and the patient's own view of the plan, lifted out of the
// diet plan list into their own screen. DietViews owns the tab switch between
// the two, so this page is just the frame around it.
const DietAdherencePage: React.FC = () => (
  <div className="diet-adherence-page-container">
    <PageHeader title="Adherence & User View" />

    <DietViews />
  </div>
);

export default DietAdherencePage;
